/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-10-14 14:46:58
 * @LastEditTime: 2019-10-14 15:51:09
 * @LastEditors: Please set LastEditors
 */
import router from '../router'
import weui from 'weui.js'
const env = require('../../static/config')
let Fly = require('flyio/dist/npm/fly')
var fly = new Fly()
fly.config.baseURL = env.linkUrl
fly.config.headers['X-Tag'] = 'flyio'
fly.config.headers['Content-Type'] = 'application/json;charset=UTF-8'
// success为false不报错的接口
const specialRequestUrl = [
  '/h5/star/task/share/to/picture',
  '/component/wechat/login/check/and/send/msg',
  '/h5/star/task/team/join'
]
// 没有转圈的接口
const noLoadingRequestUrl = [
  '/h5/star/task/popularize/watch/live/prize/config',
  '/h5/star/task/enroll/handler/activity/read',
  '/h5/star/task/enroll/handler/activity/watch/live',
  '/star/live/manage/star/data/live/buried/point'
]
// 添加请求拦截器
fly.interceptors.request.use(request => {
  // 给所有请求添加自定义header
  // console.log(localStorage.getItem('STAR_GUEST_TOKEN'))
  if (localStorage.getItem('STAR_GUEST_TOKEN')) {
    request.headers['tk'] = localStorage.getItem('STAR_GUEST_TOKEN')
  }
  let authParams = {
    // 公共参数
    // wechatId: localStorage.getItem('wechatId') ? localStorage.getItem('wechatId') : '',
    domain: location.host
  }
  request.body &&
    Object.keys(request.body).forEach(val => {
      if (!request.body[val] || request.body[val] === '') {
        delete request.body[val]
      }
    })
  request.params &&
    Object.keys(request.params).forEach(val => {
      if (!request.params[val] || request.params[val] === '') {
        delete request.params[val]
      }
    })
  console.log(request)
  if (request.method === 'POST' || request.method === 'post') {
    request.params = {
      ...request.params,
      ...authParams
    }
  } else {
    request.body = {
      ...request.body,
      ...authParams
    }
  }
  if (!noLoadingRequestUrl.includes(request.url)) {
    weui.loading('数据加载中')
  }

  // 可以通过promise.reject／resolve直接中止请求
  // promise.resolve("fake data")
  return request
})

// 添加响应拦截器，响应拦截器会在then/catch处理之前执行
fly.interceptors.response.use(
  response => {
    if (!noLoadingRequestUrl.includes(response.request.url)) {
      weui.loading().hide()
    }
    if (response.data.code === -998 || response.data.code === -999 || response.data.code === 300013) {
      router.replace({
        path: '/author',
        query: {
          errorCode: response.data.code
        }
      })
      return response.data
    }
    if (response.data.code === 20016 || response.data.code === 861003016 || response.data.code === 861003001) {
      localStorage.removeItem('IS_CIMEN_STAR_USER')
      router.push({
        path: '/login'
      })
      // let locationHref = window.location.href
      // let href = locationHref.substring(0, locationHref.lastIndexOf('#'))
      // window.location.href = '/sms/index.html?fromurl=' + locationHref
      return response.data
    }
    if (specialRequestUrl.includes(response.request.url)) {
      return response.data
    }
    if (!response.data.success) {
      weui.toast(response.data.message + '(' + response.data.code + ')', {
        duration: 2000,
        className: 'toast_text'
      })
    }
    // 只将请求结果的data字段返回
    return response.data
  },
  err => {
    console.log(err)
    weui.loading().hide()
    // alert(JSON.stringify(err))
    weui.toast('网络异常', {
      duration: 2000,
      className: 'toast_cancel'
    })
  }
)

export default fly



// WEBPACK FOOTER //
// ./src/utils/flyio.js